// extracted by mini-css-extract-plugin
export default {"block":"BlockPause_block__kGucI","load":"BlockPause_load__AdjRP","second":"BlockPause_second__NoEkB","icon":"BlockPause_icon__OgMbF"};